import type { SetDiscountConfig } from '#lib/features/live-drop-info/types.js';

type AdditionalOption = {
	item?:
		| ({ __typename?: string } & {
				label?: string | null;
				discount_percentage?: number | null;
				products?: Array<{
					ECM_Product_id?: { id?: string | null } | null;
				} | null> | null;
		  })
		| null;
} | null;

// The Drop_Set_Discount_Configs among a drop config's additional options. A
// set without a positive percentage or without products can never apply, so
// it is left out.
export const getSetDiscountConfigs = (
	additionalOptions: AdditionalOption[] | null | undefined
): SetDiscountConfig[] =>
	(additionalOptions ?? []).flatMap((additionalOption) => {
		const item = additionalOption?.item;

		if (item?.__typename !== 'Drop_Set_Discount_Config') {
			return [];
		}

		const productIds = (item.products ?? [])
			.map((product) => product?.ECM_Product_id?.id)
			.filter((id): id is string => !!id);

		if (!item.discount_percentage || item.discount_percentage <= 0) {
			return [];
		}

		if (!productIds.length) {
			return [];
		}

		return [
			{
				label: item.label,
				discountPercentage: item.discount_percentage,
				productIds,
			},
		];
	});
